import config from '@/config'

import { format, register } from 'timeago.js'

const localeFunc = (number, index) => {
  return [
    ['agora mesmo', 'daqui um pouco'],
    ['há %s segundos', 'em %s segundos'],
    ['há um minuto', 'em um minuto'],
    ['há %s minutos', 'em %s minutos'],
    ['há uma hora', 'em uma hora'],
    ['há %s horas', 'em %s horas'],
    ['há um dia', 'em um dia'],
    ['há %s dias', 'em %s dias'],
    ['há uma semana', 'em uma semana'],
    ['há %s semanas', 'em %s semanas'],
    ['há um mês', 'em um mês'],
    ['há %s meses', 'em %s meses'],
    ['há um ano', 'em um ano'],
    ['há %s anos', 'em %s anos']
  ][index]
}
// register your locale with timeago
register('br', localeFunc)

let timerControl = []
export function asyncTimeOut (idenficador) {
  return new Promise((resolve) => {
    if (timerControl[idenficador]) clearTimeout(timerControl[idenficador])
    timerControl[idenficador] = setTimeout(resolve, config.timeOut)
  })
}

export function objetoEqui (a, b) {
  // Create arrays of property names
  let aProps = Object.getOwnPropertyNames(clone(a))
  let bProps = Object.getOwnPropertyNames(clone(b))

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) return false

  for (let i = 0; i < aProps.length; i++) {
    let propName = aProps[i]
    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) return false
  }

  // If we made it this far, objects
  // are considered equivalent
  return true
}

export function ultimosItens (list, field) {
  const result = []
  function percorre (item) {
    item.forEach(element => {
      if (element[field].length > 0) return percorre(element[field])
      return result.push(element)
    })
  }
  percorre(list)
  return result
}

export function clone (object) {
  return JSON.parse(JSON.stringify(object))
}

export function deleteProp (object, field) {
  object[field] = undefined
  delete object[field]
  return object
}

export function mascaraTelefone (n) {
  if (!n || n.length < 10 || n.length > 11) return n
  let result = `(${n[0]}${n[1]})`
  if (n.length === 11) {
    result += ` ${n[2]} ${n[3]}${n[4]}${n[5]}${n[6]}-${n[7]}${n[8]}${n[9]}${n[10]}`
  } else {
    result += ` ${n[2]}${n[3]}${n[4]}${n[5]}-${n[6]}${n[7]}${n[8]}${n[9]}`
  }
  return result
}

export function tiraMascara (valor) {
  if (!valor) return ''
  return valor.replace(/[^\d]+/g, '')
}

export function mascaraCPF (cpf) {
  if (!cpf) return cpf
  cpf = cpf.replace(/\D/g, '')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

  return cpf
}

export function cpfCompleto (cpf) {
  return (`00000000000${cpf}`).slice(-11)
}

export function inssCompleto (inss) {
  return (`0000000000${inss}`).slice(-10)
}

export function mascaraBeneficio (cpf) {
  if (!cpf) return cpf
  cpf = cpf.replace(/\D/g, '')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

  return cpf
}

export function maskFloat (numero = 0) {
  if (!isNaN(numero)) return numero
  if (typeof numero !== 'string') return parseFloat(numero)
  else {
    if (numero.includes('.') && numero.includes(',')) {
      return parseFloat(numero.split('.').join('').split(',').join('.'))
    }
    return parseFloat(numero.split(',').join('.'))
  }
}

export function numberToReal (valor) {
  valor = parseFloat(valor)
  valor = valor.toFixed(2).split('.')
  valor[0] = valor[0].split(/(?=(?:...)*$)/).join('.')
  valor[0] = valor[0].replace('-.', '-')
  return valor.join(',')
}

export function serialize (obj = null) {
  let string = ''
  if (obj) {
    Object.keys(obj).forEach(x => {
      if (obj[x] !== null && obj[x] !== '') {
        if (Array.isArray(obj[x])) {
          obj[x].forEach(value => {
            if (typeof value === 'boolean') value = value ? 1 : 0
            string += `&${x}[]=${encodeURIComponent(value)}`
          })
        } else {
          if (typeof obj[x] === 'boolean') obj[x] = obj[x] ? 1 : 0
          string += `&${x}=${encodeURIComponent(obj[x])}`
        }
      }
    })
  }
  return string.substr(1)
}

export function inArray (array, value) {
  let i = array.indexOf(value)
  if (i === -1) return false
  return true
}

export function inArrayMult (array = [], value = []) {
  let existe = false
  value.forEach(e => {
    if (inArray(array, e)) existe = true
  })
  return existe
}

export function convertToUTCDate (date = Date.now(), toUTC = false) {
  date = new Date(date)
  const localOffset = date.getTimezoneOffset() * 60000
  const localTime = date.getTime()
  if (toUTC) {
    date = localTime + localOffset
  } else {
    date = localTime - localOffset
  }
  // date = localTime
  date = new Date(date)
  return date
}

export function onlyDate (data = new Date()) {
  data = typeof data === 'string' ? data = new Date(data) : data
  data = convertToUTCDate(data, true)
  let dia = data.getDate()
  if (dia.toString().length === 1) dia = `0${dia}`
  let mes = data.getMonth()
  if (mes.toString().length === 1) mes = `0${mes}`
  let ano = data.getFullYear()

  return new Date(ano, mes, dia, 0, 0, 0, 0)
}

export function isDate (data) {
  if (typeof (data) === 'undefined' || data == null || data === 'null' || data === '') return data
  const date = typeof data === 'string' ? new Date(data) : data
  if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) return null
  else return date
}

export function roundUp (num) {
  return Math.ceil(num)
}

export function stringDate (valor) {
  if (!valor) return null
  if (typeof valor !== 'string' && typeof valor !== 'number') return valor
  valor = `${valor}`
  // Data com hora com /
  if (valor.includes(':') && valor.includes('/')) {
    let from = valor.split(' ')
    let data = from[0].split('/')
    if (data.length === 2) {
      data = ['01', data[0], data[1]]
    }
    let hora = from[1].split(':')
    return new Date(parseInt(data[2]), parseInt(data[1]) - 1, parseInt(data[0]), parseInt(hora[0]), parseInt(hora[1]))
  }
  // Data sem hora com /
  if (valor.includes('/')) {
    let from = valor.split('/')
    if (from.length === 2) {
      from = ['01', from[0], from[1]]
    }
    return new Date(parseInt(from[2]), parseInt(from[1]) - 1, parseInt(from[0]))
  }

  // Data com hora com -
  if (valor.includes(':') && valor.includes('/')) {
    let from = valor.split(' ')
    let data = from[0].split('-')
    if (data.length === 2) {
      data = [data[1], data[0], '01']
    }
    let hora = from[1].split(':')
    return new Date(parseInt(data[0]), parseInt(data[1]) - 1, parseInt(data[2]), parseInt(hora[0]), parseInt(hora[1]))
  }
  // Data sem hora com -
  if (valor.includes('/')) {
    let from = valor.split('/')
    if (from.length === 2) {
      from = [from[1], from[0], '01']
    }
    return new Date(parseInt(from[0]), parseInt(from[1]) - 1, parseInt(from[2]))
  }

  // Data continua
  if (valor.length === 6) {
    let ano = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`
    let mes = `${valor[4]}${valor[5]}`
    let dia = `01`
    return new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
  }

  if (valor.length === 8) {
    let ano = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`
    let mes = `${valor[4]}${valor[5]}`
    let dia = `${valor[6]}${valor[7]}`
    return new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
  }

  return new Date(valor)
}

export function qntoTempo (date) {
  if (date !== null) {
    let tempo = format(date, 'br')
    let arrTempo = []
    arrTempo = tempo.split(' ')
    if (arrTempo.length === 3) {
      tempo = arrTempo[0] + ' <strong>' + arrTempo[1] + '</strong> ' + arrTempo[2]
    }
    return tempo
  } else return ''
}
export function removerAcentos (value) {
  let string = value
  let mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g
  }
  for (var letra in mapaAcentosHex) {
    var expressaoRegular = mapaAcentosHex[letra]
    string = string.replace(expressaoRegular, letra)
  }
  return string
}

export function toBooleano (value) {
  if (value) {
    value = value.toLowerCase()
    if (value === 'sim') return true
    else return false
  } else return false
}

export function convertToSlug (text) {
  const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
  const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
  const p = new RegExp(a.split('').join('|'), 'g')
  return text.toString().toLowerCase().trim()
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/\./g, '')
    .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
}

export const requiredParam = (message) => { throw new Error(message) }

export function convertArmazenamento (tamanhoMb = requiredParam('Tamanho é obrigatório')) {
  if (Number(tamanhoMb) <= 0) throw new Error('Tamanho deve ser um número válido')

  if (tamanhoMb < 1) {
    return `${tamanhoMb * 1000}kb`
  } else if (tamanhoMb < 1024) {
    return `${tamanhoMb}mb`
  } else {
    return `${tamanhoMb / 1000}gb`
  }
}

export const debounce = (funcao, tempoEspera) => {
  let timeout

  return function executedFunction (...argumentos) {
    const later = () => {
      clearTimeout(timeout)
      funcao(...argumentos)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, tempoEspera)
  }
}

export const debounceAsync = (f, interval) => {
  let timer = null
  return (...args) => {
    clearTimeout(timer)
    return new Promise((resolve) => {
      timer = setTimeout(
        () => resolve(f(...args)),
        interval
      )
    })
  }
}

export function validaData (valor, validaBissexto) {
  var date = valor
  var ardt = []
  var ExpReg = new RegExp('(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}')
  ardt = date.split('/')
  for (let x = 0; x < ardt.length; x++) {
    ardt[x] = parseInt(ardt[x])
  }
  var erro = false
  var msg = null
  if (date.search(ExpReg) === -1) {
    msg = 'Data inválida'
    erro = true
  } else if (((ardt[1] === 4) || (ardt[1] === 6) || (ardt[1] === 9) || (ardt[1] === 11)) && (ardt[0] > 30)) {
    msg = 'Data inválida'
    erro = true
  } else if (ardt[1] === 2 && validaBissexto) {
    if ((ardt[0] > 28) && ((ardt[2] % 4) !== 0)) {
      msg = 'Data inválida (ano digitado não é bissexto)'
      erro = true
    } if ((ardt[0] > 29) && ((ardt[2] % 4) === 0)) {
      msg = 'Data inválida'
      erro = true
    }
  } else if (ardt[1] === 2 && (ardt[0] > 29)) {
    msg = 'Data inválida'
    erro = true
  }
  return { msg, erro }
}

export function validaPeriodo (inicial, final) {
  if (inicial !== '' && final !== '') {
    let dataInicial = new Date(inicial)
    let dataFinal = new Date(final)
    if (onlyDate(dataInicial.getTime()) > onlyDate(dataFinal.getTime())) {
      return false
    }
  }
  return true
}

export function validaRetroativo (data) {
  if (data) {
    data = new Date(data)
    let hoje = new Date()
    if (onlyDate(data.getTime()) < onlyDate(hoje.getTime())) return true
  }
  return false
}

export function datasIguais (data1, data2) {
  if (data1 && data2) {
    data1 = new Date(onlyDate(data1))
    data2 = new Date(onlyDate(data2))
    if (data1.getTime() === data2.getTime()) return true
  }
  return false
}

export function pedidoVencido (dataCalculado) {
  let dataLimite = new Date()
  dataLimite.setDate(dataLimite.getDate() - 7)
  dataCalculado = new Date(dataCalculado)
  if (dataCalculado.getTime() > dataLimite.getTime()) return false
  return true
}

export function mascaraCNPJ (cnpj) {
  if (!cnpj) return cnpj
  cnpj = cnpj.replace(/\D/g, '')
  cnpj = cnpj.replace(/(\d{2})(\d)/, '$1.$2')
  cnpj = cnpj.replace(/(\d{3})(\d)/, '$1.$2')
  cnpj = cnpj.replace(/(\d{3})(\d)/, '$1/$2')
  cnpj = cnpj.replace(/(\d{3})(\d{1,2})$/, '$1-$2')

  return cnpj
}

export function mascaraCpfOuCnpj (cpfCnpj) {
  if (!cpfCnpj) return ''
  return cpfCnpj.length < 14 ? mascaraCPF(cpfCnpj) : mascaraCNPJ(cpfCnpj)
}

export function montaAnosSelectDib (retroceder) {
  let ano = new Date().getFullYear()
  let retorno = []
  for (let x = 0; x <= retroceder; x++) {
    retorno.push({value: ano - x, label: (ano - x).toString()})
  }
  return retorno
}

export function right (str, caracteres) {
  return str.substr(str.length - caracteres, str.length)
}

export function verificaStringNull (valor, sub = '-') {
  let errosPossiveis = ['null', 'undefined', 'nan']
  if (!valor || errosPossiveis.find(v => v === valor.toLowerCase()) || !valor.trim()) return sub
  return valor
}

export const verificaSeObjetoVazio = (objeto) => Object.keys(objeto || {}).length === 0

export function FormatarDateToString (date) {
  const ano = date.getFullYear()
  const mes = String(date.getMonth() + 1).padStart(2, '0')
  const dia = String(date.getDate()).padStart(2, '0')
  const horas = String(date.getHours()).padStart(2, '0')
  const minutos = String(date.getMinutes()).padStart(2, '0')
  const segundos = String(date.getSeconds()).padStart(2, '0')
  const millisegundos = String(date.getMilliseconds()).padStart(3, '0')

  return `${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}.${millisegundos}`
}

export function TrazerDiasAtras (data, qtdDias) {
  return new Date(data.getFullYear(), data.getMonth(), data.getDate() - qtdDias)
}
export function validaDataRetroativa (data, dias = 7) {
  let dataVal = new Date(data)
  let dataRetro = new Date()
  dataRetro.setDate(dataRetro.getDate() - dias)
  return dataVal >= dataRetro
}
export function validaSenhaForte (senha) {
  const regexSenhaForte = new RegExp(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_\-+={}[]|<>?~]).{8,32}/)
  return regexSenhaForte.test(senha)
}



// WEBPACK FOOTER //
// ./src/service/util.js